module.exports = __webpack_public_path__ + "Flag-646.e529cb3d49f79808ecfbddc4e5d1f457.svg";